import axios from 'axios';

const rchClient = axios.create({
  baseURL: 'nodeapi/rch',
});

// Add a request interceptor to include headers for all requests
rchClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("JANANI_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const username = localStorage.getItem("janani_username");
    if (username) {
      config.headers.username = username;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const rchAPI = {
  login: async (data) => (await rchClient.post('/login', data)).data,
  rchLogout: async (data) => (await rchClient.post('/logout', data)).data,
  getRchBeneficiary: async (data) => (await rchClient.post('/search-beneficiary', data)).data,
  addRchBeneficiary: async (data) => (await rchClient.post('/add-beneficiary', data)).data,
  viewRchBeneficiaryData: async (data) => (await rchClient.post('/detail-view-beneficiary', data)).data,
  listRchBeneficiaries: async (data) => (await rchClient.post('/beneficiaries', data)).data,
}